import React, { Component } from "react";
import {
	setMenuTopIndex,
	setMenuLeftContent,
	setMenuLeftIndex,
} from "./../../../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import Users from "./../../../containers/admin/users/UsersContainer";
import MenuAdmin from "../Menu";

class Home extends Component {
	componentDidMount() {
		this.props.setMenuTopIndex("admin");
		this.props.setMenuLeftContent(MenuAdmin);
		this.props.setMenuLeftIndex("users");
	}

	render() {
		return <Users {...this.props} />;
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setMenuLeftContent: data => {
			dispatch(setMenuLeftContent(data));
		},
		setMenuLeftIndex: index => {
			dispatch(setMenuLeftIndex(index));
		},
		setMenuTopIndex: index => {
			dispatch(setMenuTopIndex(index));
		},
	};
};

export default connect(
	null,
	mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// src/pages/admin/users/Home.js